import type { TapToPayEvent, PaymentStatus } from './types';

type EventListener = (event: TapToPayEvent) => void;

const listeners = new Set<EventListener>();
let currentStatus: PaymentStatus = 'idle';

export function onTapToPayEvent(listener: EventListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitEvent(event: TapToPayEvent): void {
  if (event.type === 'status_change') {
    currentStatus = event.status;
  }
  listeners.forEach((fn) => { try { fn(event); } catch {} });
}

export function getStatus(): PaymentStatus {
  return currentStatus;
}
